"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelinesService = void 0;
const api_1 = require("../api");
const utils_1 = require("../utils");
class PipelinesService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    getMetricsToken(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/metrics/token?version=${params.version}`, {
            method: "POST",
        });
    }
    listPipelines(params = {}) {
        return this.fetch(`/${this.apiVersion}/pipelines?${(0, utils_1.toSearchParams)(params)}`);
    }
    getPipeline(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}?${(0, utils_1.toSearchParams)(params)}`);
    }
    createPipeline(params) {
        const { body } = params;
        return this.fetch(`/${this.apiVersion}/pipelines`, {
            method: "POST",
            body,
        });
    }
    updatePipeline(params) {
        const { id, body } = params;
        return this.fetch(`/${this.apiVersion}/pipelines/${id}`, {
            method: "PATCH",
            body,
        });
    }
    createCustomPipeline(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/custom`, {
            method: "POST",
            body: params.body,
        });
    }
    getCustomPipelineFlinkVersions() {
        return this.fetch(`/${this.apiVersion}/pipelines/custom/flink-versions`);
    }
    updateCustomPipeline(params) {
        const { id, body } = params;
        return this.fetch(`/${this.apiVersion}/pipelines/custom/${id}`, {
            method: "PATCH",
            body: body,
        });
    }
    deletePipeline(id) {
        return this.fetch(`/${this.apiVersion}/pipelines/${id}`, {
            method: "DELETE",
        });
    }
    activatePipeline(params) {
        const { start_positions, task_size, start_from_snapshot_id } = params, searchParams = __rest(params, ["start_positions", "task_size", "start_from_snapshot_id"]);
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/activate?${(0, utils_1.toSearchParams)(searchParams)}`, {
            body: { task_size, start_positions, start_from_snapshot_id },
            method: "POST",
        });
    }
    deactivatePipeline(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/deactivate?${(0, utils_1.toSearchParams)(params)}`, { method: "POST" });
    }
    streams(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/streams`);
    }
    getDependencies(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.fetch(`/${this.apiVersion}/pipelines/${params.id}/dependencies?version=${params.version}`);
            [...Object.values(result.inputs), ...Object.values(result.outputs)].forEach((v) => (v.resourceType = v.resourceType.toUpperCase()));
            return result;
        });
    }
    getOutputStream({ sql }) {
        return this.fetch(`/${this.apiVersion}/pipelines/outputStream?response_schema_v=v2&`, {
            method: "POST",
            body: { sql },
        });
    }
    getFlinkUiToken(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/flink-ui/token?${(0, utils_1.toSearchParams)(params)}`, {
            method: "POST",
        });
    }
    listSnapshots(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipelineId}/snapshots`);
    }
    getSnapshot(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipelineId}/snapshots/${params.snapshotId}`);
    }
    createSnapshot(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipeline_id}/snapshots`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
        });
    }
    deleteSnapshot(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipelineId}/snapshots/${params.snapshotId}`, {
            method: "DELETE",
        });
    }
}
exports.PipelinesService = PipelinesService;
exports.default = PipelinesService;
